import { SERVICE_TYPES } from "@/lib/services";

export const Legend = () => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-testid="service-legend">
    {Object.entries(SERVICE_TYPES).filter(([, t]) => t.active).map(([key, t]) => (
      <span key={key} className="flex items-center gap-1.5 text-xs text-slate-300" data-testid={`legend-${key}`}>
        <span className="h-2.5 w-2.5 rounded-full" style={{ background: t.hex }} />
        {t.short} <span className="text-slate-500">· {t.validity}</span>
      </span>
    ))}
  </div>
);
